export default class ResultsCalculator {

    constructor() {
        this.weeklyRentalIncome = 0;
        this.weeklyPreTotalExpenses = 0;
        this.weeklyPreCashflowEstimate = 0;
        this.weeklyPostTotalClaimableExpenses = 0;
        this.weeklyPostDeprecation = 0;
        this.weeklyPostNetTaxableAmount = 0;
        this.weeklyPostTaxRebate = 0;
        this.weeklyPostCashflowEstimate = 0;
        this.annualRentalIncome = 0;
        this.annualPreTotalExpenses = 0;
        this.annualPreCashflowEstimate = 0;
        this.annualPostTotalClaimableExpenses = 0;
        this.annualPostDeprecation = 0;
        this.annualPostNetTaxableAmount = 0;
        this.annualPostTaxRebate = 0;
        this.annualPostCashflowEstimate = 0;
        this.capitalGrowth = 7;
        this.propertyValueYear1 = 0;
        this.loanYear1 = 0;
        this.totalEquityYear1 = 0;
        this.propertyValueYear2 = 0;
        this.loanYear2 = 0;
        this.totalEquityYear2 = 0;
        this.propertyValueYear3 = 0;
        this.loanYear3= 0;
        this.totalEquityYear3 = 0;
        this.propertyValueYear4 = 0;
        this.loanYear4 = 0;
        this.totalEquityYear4 = 0;
        this.propertyValueYear5 = 0;
        this.loanYear5 = 0;
        this.totalEquityYear5 = 0;
        this.propertyValueYear6 = 0;
        this.loanYear6 = 0;
        this.totalEquityYear6 = 0;
        this.propertyValueYear7 = 0;
        this.loanYear7 = 0;
        this.totalEquityYear7 = 0;
        this.propertyValueYear8 = 0;
        this.loanYear8 = 0;
        this.totalEquityYear8 = 0;
        this.propertyValueYear9 = 0;
        this.loanYear9 = 0;
        this.totalEquityYear9 = 0;
        this.propertyValueYear10 = 0;
        this.loanYear10 = 0;
        this.totalEquityYear10 = 0;
        this.propertyValueYear11 = 0;
        this.loanYear11 = 0;
        this.totalEquityYear11 = 0;
        this.loanType = 'Principal & Interest';
        this.interestRate = 0;
        this.loanTerm = 30;
        this.loanBalanceTable = [];
    }

    copyOtherResultsCalculator(results) {
        this.weeklyRentalIncome = results.weeklyRentalIncome;
        this.weeklyPreTotalExpenses = results.weeklyPreTotalExpenses;
        this.weeklyPreCashflowEstimate = results.weeklyPreCashflowEstimate;
        this.weeklyPostTotalClaimableExpenses = results.weeklyPostTotalClaimableExpenses;
        this.weeklyPostDeprecation = results.weeklyPostDeprecation;
        this.weeklyPostNetTaxableAmount = results.weeklyPostNetTaxableAmount;
        this.weeklyPostTaxRebate = results.weeklyPostTaxRebate;
        this.weeklyPostCashflowEstimate = results.weeklyPostCashflowEstimate;
        this.annualRentalIncome = results.annualRentalIncome;
        this.annualPreTotalExpenses = results.annualPreTotalExpenses;
        this.annualPreCashflowEstimate = results.annualPreCashflowEstimate;
        this.annualPostTotalClaimableExpenses = results.annualPostTotalClaimableExpenses;
        this.annualPostDeprecation = results.annualPostDeprecation;
        this.annualPostNetTaxableAmount = results.annualPostNetTaxableAmount;
        this.annualPostTaxRebate = results.annualPostTaxRebate;
        this.annualPostCashflowEstimate = results.annualPostCashflowEstimate;
        this.capitalGrowth = results.capitalGrowth;
        this.propertyValueYear1 = results.propertyValueYear1;
        this.loanYear1 = results.loanYear1;
        this.totalEquityYear1 = results.totalEquityYear1;
        this.propertyValueYear2 = results.propertyValueYear2;
        this.loanYear2 = results.loanYear2;
        this.totalEquityYear2 = results.totalEquityYear2;
        this.propertyValueYear3 = results.propertyValueYear3;
        this.loanYear3 = results.loanYear3;
        this.totalEquityYear3 = results.totalEquityYear3;
        this.propertyValueYear4 = results.propertyValueYear4;
        this.loanYear4 = results.loanYear4;
        this.totalEquityYear4 = results.totalEquityYear4;
        this.propertyValueYear5 = results.propertyValueYear5;
        this.loanYear5 = results.loanYear5;
        this.totalEquityYear5 = results.totalEquityYear5;
        this.propertyValueYear6 = results.propertyValueYear6;
        this.loanYear6 = results.loanYear6;
        this.totalEquityYear6 = results.totalEquityYear6;
        this.propertyValueYear7 = results.propertyValueYear7;
        this.loanYear7 = results.loanYear7;
        this.totalEquityYear7 = results.totalEquityYear7;
        this.propertyValueYear8 = results.propertyValueYear8;
        this.loanYear8 = results.loanYear8;
        this.totalEquityYear8 = results.totalEquityYear8;
        this.propertyValueYear9 = results.propertyValueYear9;
        this.loanYear9 = results.loanYear9;
        this.totalEquityYear9 = results.totalEquityYear9;
        this.propertyValueYear10 = results.propertyValueYear10;
        this.loanYear10 = results.loanYear10;
        this.totalEquityYear10 = results.totalEquityYear10;
        this.propertyValueYear11 = results.propertyValueYear11;
        this.loanYear11 = results.loanYear11;
        this.totalEquityYear11 = results.totalEquityYear11;
        this.loanType = results.loanType;
        this.interestRate = results.interestRate;
        this.loanTerm = results.loanTerm;
        this.loanBalanceTable = results.loanBalanceTable;
    }

    getWeeklyRentalIncome() {
        return this.weeklyRentalIncome;
    }

    calcWeeklyRentalIncome(rentalIncomeAnnual){
        this.weeklyRentalIncome = rentalIncomeAnnual / 52;
        if (Math.floor(this.weeklyRentalIncome) !== this.weeklyRentalIncome) {
            this.weeklyRentalIncome = Math.round(this.weeklyRentalIncome);
        }
        this.calcWeeklyPreCashflowEstimate();
        this.calcWeeklyPostNetTaxableAmount();
    }

    getWeeklyPreTotalExpenses() {
        return this.weeklyPreTotalExpenses;
    }

    calcWeeklyPreTotalExpenses(totalExpenses){
        this.weeklyPreTotalExpenses = totalExpenses / 52;
        if (Math.floor(this.weeklyPreTotalExpenses) !== this.weeklyPreTotalExpenses) {
            this.weeklyPreTotalExpenses = Math.round(this.weeklyPreTotalExpenses);
        }
        this.calcWeeklyPreCashflowEstimate();
    }

    getWeeklyPreCashflowEstimate() {
        return this.weeklyPreCashflowEstimate;
    }

    calcWeeklyPreCashflowEstimate() {
        this.weeklyPreCashflowEstimate = this.weeklyRentalIncome - this.weeklyPreTotalExpenses;
        this.calcWeeklyPostCashflowEstimate();
    }

    getWeeklyPostTotalClaimableExpenses() {
        return this.weeklyPostTotalClaimableExpenses;
    }

    calcWeeklyPostTotalClaimableExpenses(totalExpenses, annualPrincipalRepayments) {
        this.weeklyPostTotalClaimableExpenses = (totalExpenses - annualPrincipalRepayments) / 52;
        if (Math.floor(this.weeklyPostTotalClaimableExpenses) !== this.weeklyPostTotalClaimableExpenses) {
            this.weeklyPostTotalClaimableExpenses = Math.round(this.weeklyPostTotalClaimableExpenses);
        }
        this.calcWeeklyPostNetTaxableAmount();
    }

    getWeeklyPostDeprecation() {
        return this.weeklyPostDeprecation;
    }

    calcWeeklyPostDeprecation(estimatedAmount, lendersMortgageInsurance) {
        this.weeklyPostDeprecation = (estimatedAmount + (lendersMortgageInsurance / 5)) / 52;
        if (Math.floor(this.weeklyPostDeprecation) !== this.weeklyPostDeprecation) {
            this.weeklyPostDeprecation = Math.round(this.weeklyPostDeprecation);
        }
        this.calcWeeklyPostNetTaxableAmount();
    }

    getWeeklyPostNetTaxableAmount() {
        return this.weeklyPostNetTaxableAmount;
    }

    calcWeeklyPostNetTaxableAmount() {
        this.weeklyPostNetTaxableAmount = this.weeklyRentalIncome - this.weeklyPostTotalClaimableExpenses - this.weeklyPostDeprecation;
    }

    getWeeklyPostTaxRebate() {
        return this.weeklyPostTaxRebate;
    }

    calcWeeklyPostTaxRebate(taxRate) {
        this.weeklyPostTaxRebate = -(taxRate/100 * this.weeklyPostNetTaxableAmount);
        if (Math.floor(this.weeklyPostTaxRebate) !== this.weeklyPostTaxRebate) {
            this.weeklyPostTaxRebate = Math.round(this.weeklyPostTaxRebate);
        }
        this.calcWeeklyPostCashflowEstimate();
    }

    getWeeklyPostCashflowEstimate() {
        return this.weeklyPostCashflowEstimate;
    }

    calcWeeklyPostCashflowEstimate() {
        this.weeklyPostCashflowEstimate = this.weeklyPreCashflowEstimate + this.weeklyPostTaxRebate;
    }

    getAnnualRentalIncome() {
        return this.annualRentalIncome;
    }

    calcAnnualRentalIncome(rentalIncomeAnnual) {
        this.annualRentalIncome = rentalIncomeAnnual;
        this.calcAnnualPreCashflowEstimate();
        this.calcAnnualPostNetTaxableAmount();
    }

    getAnnualPreTotalExpenses() {
        return this.annualPreTotalExpenses;
    }

    calcAnnualPreTotalExpenses(totalExpenses) {
        this.annualPreTotalExpenses = totalExpenses;
        this.calcAnnualPreCashflowEstimate();
    }

    getAnnualPreCashflowEstimate() {
        return this.annualPreCashflowEstimate;
    }

    calcAnnualPreCashflowEstimate() {
        this.annualPreCashflowEstimate = this.annualRentalIncome - this.annualPreTotalExpenses;
        this.calcAnnualPostCashflowEstimate();
    }

    getAnnualPostTotalClaimableExpenses() {
        return this.annualPostTotalClaimableExpenses;
    }

    calcAnnualPostTotalClaimableExpenses(totalExpenses, annualPrincipalRepayments) {
        this.annualPostTotalClaimableExpenses = totalExpenses - annualPrincipalRepayments;
        this.calcAnnualPostNetTaxableAmount();
    }

    getAnnualPostDeprecation() {
        return this.annualPostDeprecation;
    }

    calcAnnualPostDeprecation(estimatedAmount, lendersMortgageInsurance) {
        this.annualPostDeprecation = estimatedAmount + (lendersMortgageInsurance / 5);
        if (Math.floor(this.annualPostDeprecation) !== this.annualPostDeprecation) {
            this.annualPostDeprecation = Math.round(this.annualPostDeprecation);
        }
        this.calcAnnualPostNetTaxableAmount();
    }

    getAnnualPostNetTaxableAmount() {
        return this.annualPostNetTaxableAmount;
    }

    calcAnnualPostNetTaxableAmount() {
        this.annualPostNetTaxableAmount = this.annualRentalIncome - this.annualPostTotalClaimableExpenses - this.annualPostDeprecation;
    }

    getAnnualPostTaxRebate() {
        return this.annualPostTaxRebate;
    }

    calcAnnualPostTaxRebate(taxRate) {
        this.annualPostTaxRebate = -(taxRate/100 * this.annualPostNetTaxableAmount);
        if (Math.floor(this.annualPostTaxRebate) !== this.annualPostTaxRebate) {
            this.annualPostTaxRebate = Math.round(this.annualPostTaxRebate);
        }
        this.calcAnnualPostCashflowEstimate();
    }

    getAnnualPostCashflowEstimate() {
        return this.annualPostCashflowEstimate;
    }

    calcAnnualPostCashflowEstimate() {
        this.annualPostCashflowEstimate = this.annualPreCashflowEstimate + this.annualPostTaxRebate;
    }

    setCapitalGrowth(capitalGrowth) {
        this.capitalGrowth = Number(capitalGrowth);
    }

    getCapitalGrowth() {
        return this.capitalGrowth;
    }

    setPropertyValueYear1(propertyValueYear1) {
        this.propertyValueYear1 = propertyValueYear1;
        this.setPropertyValueYear2();
    }

    getPropertyValueYear1() {
        return this.propertyValueYear1;
    }

    setLoanYear1(loanYear1) {
        this.loanYear1 = loanYear1;
        this.setLoanYear2();
    }

    getLoanYear1() {
        return this.loanYear1;
    }

    getTotalEquityYear1() {
        return this.totalEquityYear1;
    }

    calcTotalEquityYear1() {
        this.totalEquityYear1 = this.propertyValueYear1 - this.loanYear1;
    }

    setPropertyValueYear2() {
        this.propertyValueYear2 = ((this.propertyValueYear1 * this.capitalGrowth) / 100) + this.propertyValueYear1;
        this.setPropertyValueYear3();
    }

    getPropertyValueYear2() {
        return this.propertyValueYear2;
    }

    setLoanYear2() {
        if (this.loanType === 'Interest Only') {
            this.loanYear2 = this.loanYear1;
        } else if (this.loanType === 'Principal & Interest') {
            this.loanYear2 = Math.round(this.loanBalanceTable[0]);
            if (isNaN(this.loanYear2)) {
                this.loanYear2 = 0;
            }
        }
        this.setLoanYear3();
    }

    getLoanYear2() {
        return this.loanYear2;
    }

    getTotalEquityYear2() {
        return this.totalEquityYear2;
    }

    calcTotalEquityYear2() {
        this.totalEquityYear2 = this.propertyValueYear2 - this.loanYear2;
    }

    setPropertyValueYear3() {
        this.propertyValueYear3 = ((this.propertyValueYear2 * this.capitalGrowth) / 100) + this.propertyValueYear2;
        this.setPropertyValueYear4();
    }

    getPropertyValueYear3() {
        return this.propertyValueYear3;
    }

    setLoanYear3() {
        if (this.loanType === 'Interest Only') {
            this.loanYear3 = this.loanYear1;
        } else if (this.loanType === 'Principal & Interest') {
            this.loanYear3 = Math.round(this.loanBalanceTable[1]);
            if (isNaN(this.loanYear3)) {
                this.loanYear3 = 0;
            }
        }
        this.setLoanYear4();
    }

    getLoanYear3() {
        return this.loanYear3;
    }

    getTotalEquityYear3() {
        return this.totalEquityYear3;
    }

    calcTotalEquityYear3() {
        this.totalEquityYear3 = this.propertyValueYear3 - this.loanYear3;
    }

    setPropertyValueYear4() {
        this.propertyValueYear4 = ((this.propertyValueYear3 * this.capitalGrowth) / 100) + this.propertyValueYear3;
        this.setPropertyValueYear5();
    }

    getPropertyValueYear4() {
        return this.propertyValueYear4;
    }

    setLoanYear4() {
        if (this.loanType === 'Interest Only') {
            this.loanYear4 = this.loanYear1;
        } else if (this.loanType === 'Principal & Interest') {
            this.loanYear4 = Math.round(this.loanBalanceTable[2]);
            if (isNaN(this.loanYear4)) {
                this.loanYear4 = 0;
            }
        }

        this.setLoanYear5();
    }

    getLoanYear4() {
        return this.loanYear4;
    }

    getTotalEquityYear4() {
        return this.totalEquityYear4;
    }

    calcTotalEquityYear4() {
        this.totalEquityYear4 = this.propertyValueYear4 - this.loanYear4;
    }

    setPropertyValueYear5() {
        this.propertyValueYear5 = ((this.propertyValueYear4 * this.capitalGrowth) / 100) + this.propertyValueYear4;
        this.setPropertyValueYear6();
    }

    getPropertyValueYear5() {
        return this.propertyValueYear5;
    }

    setLoanYear5() {
        if (this.loanType === 'Interest Only') {
            this.loanYear5 = this.loanYear1;
        } else if (this.loanType === 'Principal & Interest') {
            this.loanYear5 = Math.round(this.loanBalanceTable[3]);
            if (isNaN(this.loanYear5)) {
                this.loanYear5 = 0;
            }
        }

        this.setLoanYear6();
    }

    getLoanYear5() {
        return this.loanYear5;
    }

    getTotalEquityYear5() {
        return this.totalEquityYear5;
    }

    calcTotalEquityYear5() {
        this.totalEquityYear5 = this.propertyValueYear5 - this.loanYear5;
    }

    setPropertyValueYear6() {
        this.propertyValueYear6 = ((this.propertyValueYear5 * this.capitalGrowth) / 100) + this.propertyValueYear5;
        this.setPropertyValueYear7();
    }

    getPropertyValueYear6() {
        return this.propertyValueYear6;
    }

    setLoanYear6() {
        if (this.loanType === 'Interest Only') {
            this.loanYear6 = this.loanYear1;
        } else if (this.loanType === 'Principal & Interest') {
            this.loanYear6 = Math.round(this.loanBalanceTable[4]);
            if (isNaN(this.loanYear6)) {
                this.loanYear6 = 0;
            }
        }

        this.setLoanYear7();
    }

    getLoanYear6() {
        return this.loanYear6;
    }

    getTotalEquityYear6() {
        return this.totalEquityYear6;
    }

    calcTotalEquityYear6() {
        this.totalEquityYear6 = this.propertyValueYear6 - this.loanYear6;
    }

    setPropertyValueYear7() {
        this.propertyValueYear7 = ((this.propertyValueYear6 * this.capitalGrowth) / 100) + this.propertyValueYear6;
        this.setPropertyValueYear8();
    }

    getPropertyValueYear7() {
        return this.propertyValueYear7;
    }

    setLoanYear7() {
        if (this.loanType === 'Interest Only') {
            this.loanYear7 = this.loanYear1;
        } else if (this.loanType === 'Principal & Interest') {
            this.loanYear7 = Math.round(this.loanBalanceTable[5]);
            if (isNaN(this.loanYear7)) {
                this.loanYear7 = 0;
            }
        }

        this.setLoanYear8();
    }

    getLoanYear7() {
        return this.loanYear7;
    }

    getTotalEquityYear7() {
        return this.totalEquityYear7;
    }

    calcTotalEquityYear7() {
        this.totalEquityYear7 = this.propertyValueYear7 - this.loanYear7;
    }

    setPropertyValueYear8() {
        this.propertyValueYear8 = ((this.propertyValueYear7 * this.capitalGrowth) / 100) + this.propertyValueYear7;
        this.setPropertyValueYear9();
    }

    getPropertyValueYear8() {
        return this.propertyValueYear8;
    }

    setLoanYear8() {
        if (this.loanType === 'Interest Only') {
            this.loanYear8 = this.loanYear1;
        } else if (this.loanType === 'Principal & Interest') {
            this.loanYear8 = Math.round(this.loanBalanceTable[6]);
            if (isNaN(this.loanYear8)) {
                this.loanYear8 = 0;
            }
        }

        this.setLoanYear9();
    }

    getLoanYear8() {
        return this.loanYear8;
    }

    getTotalEquityYear8() {
        return this.totalEquityYear8;
    }

    calcTotalEquityYear8() {
        this.totalEquityYear8 = this.propertyValueYear8 - this.loanYear8;
    }

    setPropertyValueYear9() {
        this.propertyValueYear9 = ((this.propertyValueYear8 * this.capitalGrowth) / 100) + this.propertyValueYear8;
        this.setPropertyValueYear10();
    }

    getPropertyValueYear9() {
        return this.propertyValueYear9;
    }

    setLoanYear9() {
        if (this.loanType === 'Interest Only') {
            this.loanYear9 = this.loanYear1;
        } else if (this.loanType === 'Principal & Interest') {
            this.loanYear9 = Math.round(this.loanBalanceTable[7]);
            if (isNaN(this.loanYear9)) {
                this.loanYear9 = 0;
            }
        }

        this.setLoanYear10();
    }

    getLoanYear9() {
        return this.loanYear9;
    }

    getTotalEquityYear9() {
        return this.totalEquityYear9;
    }

    calcTotalEquityYear9() {
        this.totalEquityYear9 = this.propertyValueYear9 - this.loanYear9;
    }

    setPropertyValueYear10() {
        this.propertyValueYear10 = ((this.propertyValueYear9 * this.capitalGrowth) / 100) + this.propertyValueYear9;
        this.setPropertyValueYear11();
    }

    getPropertyValueYear10() {
        return this.propertyValueYear10;
    }

    setLoanYear10() {
        if (this.loanType === 'Interest Only') {
            this.loanYear10 = this.loanYear1;
        } else if (this.loanType === 'Principal & Interest') {
            this.loanYear10 = Math.round(this.loanBalanceTable[8]);
            if (isNaN(this.loanYear10)) {
                this.loanYear10 = 0;
            }
        }

        this.setLoanYear11();
    }

    getLoanYear10() {
        return this.loanYear10;
    }

    getTotalEquityYear10() {
        return this.totalEquityYear10;
    }

    calcTotalEquityYear10() {
        this.totalEquityYear10 = this.propertyValueYear10 - this.loanYear10;
    }

    setPropertyValueYear11() {
        this.propertyValueYear11 = ((this.propertyValueYear10 * this.capitalGrowth) / 100) + this.propertyValueYear10;
        this.propertyValueYear2 = Math.round(this.propertyValueYear2);
        this.propertyValueYear3 = Math.round(this.propertyValueYear3);
        this.propertyValueYear4 = Math.round(this.propertyValueYear4);
        this.propertyValueYear5 = Math.round(this.propertyValueYear5);
        this.propertyValueYear6 = Math.round(this.propertyValueYear6);
        this.propertyValueYear7 = Math.round(this.propertyValueYear7);
        this.propertyValueYear8 = Math.round(this.propertyValueYear8);
        this.propertyValueYear9 = Math.round(this.propertyValueYear9);
        this.propertyValueYear10 = Math.round(this.propertyValueYear10);
        this.propertyValueYear11 = Math.round(this.propertyValueYear11);
        this.calcTotalEquityYear1();
        this.calcTotalEquityYear2();
        this.calcTotalEquityYear3();
        this.calcTotalEquityYear4();
        this.calcTotalEquityYear5();
        this.calcTotalEquityYear6();
        this.calcTotalEquityYear7();
        this.calcTotalEquityYear8();
        this.calcTotalEquityYear9();
        this.calcTotalEquityYear10();
        this.calcTotalEquityYear11();
    }

    getPropertyValueYear11() {
        return this.propertyValueYear11
    }

    setLoanYear11() {
        if (this.loanType === 'Interest Only') {
            this.loanYear11 = this.loanYear1;
        } else if (this.loanType === 'Principal & Interest') {
            this.loanYear11 = Math.round(this.loanBalanceTable[9]);
            if (isNaN(this.loanYear11)) {
                this.loanYear11 = 0;
            }
        }

        this.calcTotalEquityYear1();
        this.calcTotalEquityYear2();
        this.calcTotalEquityYear3();
        this.calcTotalEquityYear4();
        this.calcTotalEquityYear5();
        this.calcTotalEquityYear6();
        this.calcTotalEquityYear7();
        this.calcTotalEquityYear8();
        this.calcTotalEquityYear9();
        this.calcTotalEquityYear10();
        this.calcTotalEquityYear11();
    }

    getLoanYear11() {
        return this.loanYear11;
    }

    getTotalEquityYear11() {
        return this.totalEquityYear11;
    }

    calcTotalEquityYear11() {
        this.totalEquityYear11 = this.propertyValueYear11 - this.loanYear11;
    }

    pmt(rate, nper, pv) {
        return  ( rate/100/12 * pv) / (1 - Math.pow((1 + rate/100/12), -nper*12));
    }

    setLoanType(loanType) {
        this.loanType = loanType;
    }

    getLoanType() {
        return this.loanType;
    }

    setInterestRate(interestRate) {
        this.interestRate = Number(interestRate);
    }

    getInterestRate() {
        return this.loanType;
    }

    setLoanTerm(loanTerm) {
        this.loanTerm = Number(loanTerm);
    }

    getLoanTerm() {
        return this.loanTerm;
    }

    setLoanBalanceTable(loanBalanceTable) {
        this.loanBalanceTable = loanBalanceTable;
    }
}


// WEBPACK FOOTER //
// ./src/Classes/ResultsCalculator.js